var map = {
	"./1-solid.svg": 994,
	"./2-solid.svg": 995,
	"./3-solid.svg": 996,
	"./4-solid.svg": 997,
	"./5-solid.svg": 998,
	"./A-solid.svg": 999,
	"./B-solid.svg": 1000,
	"./C-solid.svg": 1001,
	"./D-solid.svg": 1002,
	"./E-solid.svg": 1003,
	"./H-solid.svg": 1004,
	"./P-solid.svg": 1005,
	"./S-solid.svg": 1006,
	"./T-solid.svg": 1007,
	"./applause.svg": 1008,
	"./arrow-down-diagonal.svg": 1009,
	"./arrow-down-solid.svg": 1010,
	"./arrow-up-diagonal.svg": 1011,
	"./arrow-up-solid.svg": 1012,
	"./ban-solid.svg": 1013,
	"./bolt-solid.svg": 1014,
	"./check-solid.svg": 1015,
	"./coins-solid.svg": 1016,
	"./comment-regular.svg": 1017,
	"./crossroad.svg": 1018,
	"./dead-end.svg": 1019,
	"./digital.svg": 1020,
	"./dollar.svg": 1021,
	"./double-side-arrow.svg": 1022,
	"./euro.svg": 1023,
	"./exclamation-triangle-solid.svg": 1024,
	"./fire-solid.svg": 1025,
	"./flag-solid.svg": 1026,
	"./gift.svg": 1027,
	"./hand-paper-solid.svg": 1028,
	"./heart-broken-solid.svg": 1029,
	"./heart-solid.svg": 1030,
	"./hourglass-half-solid.svg": 1031,
	"./human.svg": 1032,
	"./info-solid.svg": 1033,
	"./key.svg": 1034,
	"./left-arrow.svg": 1035,
	"./lightbulb-solid.svg": 1036,
	"./location.svg": 1037,
	"./lock.svg": 1038,
	"./loop.svg": 1039,
	"./map-pin-solid.svg": 1040,
	"./money-bill-wave-solid.svg": 1041,
	"./pound.svg": 1042,
	"./question-solid.svg": 1043,
	"./recycle.svg": 1044,
	"./right-arrow.svg": 1045,
	"./search-solid.svg": 1046,
	"./star-of-life-solid.svg": 1047,
	"./star-solid.svg": 1048,
	"./start.svg": 1049,
	"./stop-solid.svg": 1050,
	"./target.svg": 1051,
	"./thumbs-down-solid.svg": 1052,
	"./thumbs-up-solid.svg": 1053,
	"./times-solid.svg": 1054,
	"./wrench-solid.svg": 1055
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;